import { LOGOUT_USER } from './store';
export var metaReducers = [rootReducer];
export function rootReducer(reducer) {
    return function (state, action) {
        switch (action.type) {
            case LOGOUT_USER:
                state = undefined;
        }
        return reducer(state, action);
    };
}
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export function tokenGetter() {
    return localStorage.getItem('token');
}



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/app.module.ts.pre-build-optimizer.js